module.exports = __webpack_public_path__ + "img/special_minds.59a4dfa7.png";